import { ProgressCircle, ProgressCircleProps } from "./progress-circle";

type LoadingProps = {
  size?: ProgressCircleProps["size"];
  description?: string;
};

const Loading = ({ size = "large", description }: LoadingProps) => (
  <div className="absolute inset-0 bg-white/60 z-modal flex justify-center items-center">
    <ProgressCircle description={description} size={size} />
  </div>
);

export { LoadingProps, Loading };
